module.exports = __webpack_public_path__ + "static/media/customers4.4bccb001.png";